import { render, staticRenderFns } from "./Overseas.vue?vue&type=template&id=32135a12&scoped=true&"
import script from "./Overseas.vue?vue&type=script&lang=js&"
export * from "./Overseas.vue?vue&type=script&lang=js&"
import style0 from "./Overseas.vue?vue&type=style&index=0&id=32135a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32135a12",
  null
  
)

export default component.exports